import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { round } from '../helper';

import './Table.css';

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    };
  }

  render() {
    const { data } = this.state;
    const {
      headRow, pageSize, pagination, id
    } = this.props;
    const columnsConfig = (header) => [
      {
        Header: id,
        id,
        className: 'center',
        accessor: (d) => d[header],
        filterMethod: (filter, row) => row[filter.id].startsWith(filter.value.toUpperCase()),
        Filter: ({ filter, onChange }) => (
          <input
            aria-label="Municipality name to search for"
            placeholder="Enter a municipality name ..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        )
      },
      {
        Header: 'Trips started',
        id: 'originTrips',
        className: 'center',
        accessor: (d) => d.ORIGIN_TRIPS,
        Cell: (row) => (<div>{row.value.toLocaleString()}</div>),
        filterable: false
      },
      {
        Header: 'Trips started per person',
        id: 'originTripsPerCap',
        className: 'center',
        accessor: (d) => round(d.ORIGIN_TRIPS_PER_PERSON, 2),
        filterable: false
      }
    ];
    return(
      <ReactTable
        data={data}
        filterable={id === 'Municipality'}
        columns={columnsConfig(headRow)}
        defaultPageSize={pageSize}
        defaultSorted={[
          {
            id: 'originTrips',
            desc: true
          }
        ]}
        className="-striped -highlight"
        showPaginationBottom={pagination}
      />
    );
  }
}

Table.propTypes = {
  data: PropTypes.array,
  headRow: PropTypes.string,
  pageSize: PropTypes.number,
  pagination: PropTypes.bool,
  id: PropTypes.string
};

export default Table;
